import {
    BuildFreshness,
    CMA,
    DeploymentMonitor,
    DeploymentOCETroubleshooting,
    FuseBot,
    Handoffs,
    IdentityHub,
    Interceptor,
    Maas,
    MdoIncidentsHub,
    OrchestrationHub,
    PrAssistant,
    RuleRolloutDashboard,
    SecretInventory,
    SubstrateApp,
    SvcHealthDashboard,
    TorusDashBoard,
    TransportHeatmapV2,
    TransportQueueLegacy,
    TransportReportingLegacy,
    TransportSLA,
    TransportXamProbeHeatmap,
    Volume,
    WhereIsMyFix as WhereIsMyFixLegacy
} from "./RedirectionApp/RedirectionApp.setting";

import { AgencyHub } from "./AgencyHub/AgencyHubApp.setting";
import { AppHub } from "./AppHub/AppHubApp.setting";
import { ApsHub } from "./ApsHub/ApsHubApp.setting";
import { BIPartnerCenter } from "./BIPartnerCenter/BIPartnerCenterApp.setting";
import { BusinessInsights } from "./BusinessInsights/BusinessInsightsApp.setting";
import { ChangeInventory } from "./ChangeInventory/ChangeInventoryApp.setting";
import { Contacts } from "Apps/Contacts/ContactsApp.setting";
import { CorpIdentity } from "./CorpIdentity/CorpIdentityApp.setting";
import { CustomerHub } from "./CustomerHub/CustomerHubApp.setting";
import { Dare } from "./Dare/DareApp.setting";
import { Dashboard } from "Apps/Dashboard/DashboardApp.setting";
import { DeploymentHub } from "./DeploymentHub/DeploymentHubApp.setting";
import { FindLid } from "./FindLid/FindLidApp.setting";
import { Fleet } from "./Fleet/FleetApp.setting";
import { GriffinControlPlane } from "./GriffinControlPlane/GriffinControlPlaneApp.setting";
import { GuardianAI } from "./GuardianAI/GuardianAIApp.setting";
import { HelloWorld } from "./HelloWorld/HelloWorldApp.setting";
import { IC3IEG } from "./IC3IEG/IC3IEGApp.setting";
import { IC3SPoG } from "./IC3SPoG/IC3SPoGApp.setting";
import { IncidentIntelligence } from "./IncidentIntelligence/IncidentIntelligenceApp.setting";
import { Incidents } from "Apps/Incident/IncidentApp.setting";
import { JobMgmt } from "./JobMgmt/JobMgmtApp.setting";
import { Kevlar } from "./Kevlar/KevlarApp.setting";
import { M365Health } from "Apps/Health/HealthApp.setting";
import { MPA } from "./MPA/MPAApp.setting";
import { Networking } from "./Networking/NetworkingApp.setting";
import { NotificationCenter } from "./NotificationCenter/NotificationCenterApp.setting";
import { OnCallLoadBalancer } from "./OnCallLoadBalancer/OnCallLoadBalancerApp.setting";
import { OnR } from "./OnR/OnRApp.setting";
import { OpsGenie } from "./OpsGenie/OpsGenieApp.setting";
import { Pathfinder } from "./Pathfinder/PathfinderApp.setting";
import { PerfSpy } from "./PerfSpy/PerfSpyApp.setting";
import { PulseMetrics } from "./PulseMetrics/PulseMetricsApp.setting";
import { R9 } from "./R9/R9App.setting";
import { Rbac } from "./Rbac/RbacApp.setting";
import { RecoveryControlPanel } from "./RecoveryControlPanel/RecoveryControlPanelApp.setting";
import { ResilienceHub } from "./ResilienceHub/ResilienceHubApp.setting";
import { Rules } from "./Rules/RulesApp.setting";
import { RuntimeInsights } from "./RuntimeInsights/RuntimeInsightsApp.setting";
import { SCPHub } from "./SCPHub/SCPHubApp.setting";
import { SLC } from "./SLC/SLCApp.setting";
import { SOTELS } from "./SOTELS/SOTELSApp.setting";
import { Sarc } from "./Sarc/SarcApp.setting";
import { Scenarios } from "./Scenarios/ScenariosApp.setting";
import { Server } from "Apps/Server/ServerApp.setting";
import { Service } from "Apps//Service/ServiceApp.setting";
import { SovCloudOps } from "./SovereignCloudOps/SovereignCloudOpsApp.setting";
import { Teams } from "Apps/Teams/TeamsApp.setting";
import { Torus } from "./Torus/TorusApp.setting";
import { TorusDeployMetric } from "./TorusDeployMetric/TorusDeployMetricApp.setting";
import { TransportQueue } from "./TransportQueue/TransportQueueApp.setting";
import { TransportReporting } from "./TransportReporting/TransportReportingApp.setting";
import { UDC } from "./UDC/UDCApp.setting";
import { UMS } from "./UMS/UMSApp.setting";
import { WhereIsMyFix } from "./WhereIsMyFix/WhereIsMyFixApp.setting";

import { CanaryHealth } from "./CanaryHealth/CanaryHealthApp.setting";
import { ODLPortal } from "./ODLPortal/ODLPortalApp.setting";
//DO NOT REMOVE {AppImport}

export const AppRegistry = {
    Dashboard: { ...Dashboard },
    M365Health: { ...M365Health },
    Incidents: { ...Incidents },
    Teams: { ...Teams },
    Server: { ...Server },
    Contacts: { ...Contacts },
    Service: { ...Service },
    CustomerHub: { ...CustomerHub },
    AppHub: { ...AppHub },
    SovCloudOps: { ...SovCloudOps },
    RuntimeInsights: { ...RuntimeInsights },
    SCPHub: { ...SCPHub },
    CMA: { ...CMA },
    OpsGenie: { ...OpsGenie },
    SOTELS: { ...SOTELS },
    IC3SPoG: { ...IC3SPoG },
    DeploymentHub: { ...DeploymentHub },
    Fleet: { ...Fleet },
    Rules: { ...Rules },
    IC3IEG: { ...IC3IEG },
    Scenarios: { ...Scenarios },
    MPA: { ...MPA },
    Kevlar: { ...Kevlar },
    BusinessInsights: { ...BusinessInsights },
    NotificationCenter: { ...NotificationCenter },
    CorpIdentity: { ...CorpIdentity },
    WhereIsMyFix: { ...WhereIsMyFix },
    WhereIsMyFixLegacy: { ...WhereIsMyFixLegacy },
    DeploymentMonitor: { ...DeploymentMonitor },
    PerfSpy: { ...PerfSpy },
    IdentityHub: { ...IdentityHub },
    TransportSLA: { ...TransportSLA },
    Handoffs: { ...Handoffs },
    Dare: { ...Dare },
    ApsHub: { ...ApsHub },
    ODLPortal: { ...ODLPortal },
    ResilienceHub: { ...ResilienceHub },
    UMS: { ...UMS },
    Torus: { ...Torus },
    JobMgmt: { ...JobMgmt },
    Networking: { ...Networking },
    RecoveryControlPanel: { ...RecoveryControlPanel },
    BIPartnerCenter: { ...BIPartnerCenter },
    OnR: { ...OnR },
    ChangeInventory: { ...ChangeInventory },
    SecretInventory: { ...SecretInventory },
    TransportQueue: { ...TransportQueue },
    R9: { ...R9 },
    UDC: { ...UDC },
    Pathfinder: { ...Pathfinder },
    GuardianAI: { ...GuardianAI },
    SLC: { ...SLC },
    FindLid: { ...FindLid },
    Sarc: { ...Sarc },
    TransportReporting: { ...TransportReporting },
    AgencyHub: { ...AgencyHub },
    GriffinControlPlane: { ...GriffinControlPlane },
    PulseMetrics: { ...PulseMetrics },
    // v1-only legacy redirect apps (appear in App Hub "Legacy v1 Apps" tab)
    SubstrateApp: { ...SubstrateApp },
    MdoIncidentsHub: { ...MdoIncidentsHub },
    RuleRolloutDashboard: { ...RuleRolloutDashboard },
    SvcHealthDashboard: { ...SvcHealthDashboard },
    BuildFreshness: { ...BuildFreshness },
    DeploymentOCETroubleshooting: { ...DeploymentOCETroubleshooting },
    OrchestrationHub: { ...OrchestrationHub },
    FuseBot: { ...FuseBot },
    PrAssistant: { ...PrAssistant },
    Maas: { ...Maas },
    Rbac: { ...Rbac },
    TorusDashBoard: { ...TorusDashBoard }, // Phase 2 (added 2026-05-08)
    Interceptor: { ...Interceptor },
    TransportHeatmapV2: { ...TransportHeatmapV2 },
    TransportXamProbeHeatmap: { ...TransportXamProbeHeatmap },
    Volume: { ...Volume },
    IncidentIntelligence: { ...IncidentIntelligence },
    TransportQueueLegacy: { ...TransportQueueLegacy },
    TransportReportingLegacy: { ...TransportReportingLegacy },
    TorusDeployMetric: { ...TorusDeployMetric },
    OnCallLoadBalancer: { ...OnCallLoadBalancer },
    CanaryHealth: { ...CanaryHealth },
    //DO NOT REMOVE {AppConfigModel},
    HelloWorld: { ...HelloWorld }
};
